module.exports = __webpack_public_path__ + "static/10-2b00faa75bad3243368adba803c60cd2.jpg";